import React from "react";
import { VoiceRecordingConsent } from "./VoiceRecordingConsent";
import { OptionalUI } from "../OptionalParts/OptionalUI";
import { useAppState } from "../../../Redux/ReduxHooks";

/**
 * Possibly renders the voice recording consent message below the booking button for applicable locations.
 */
export const MaybeVoiceRecordingConsent: React.FC = () => {
    const isVoiceRecordingConsentRequired = useAppState(OptionalUI.VoiceRecordingConsent);

    if (!isVoiceRecordingConsentRequired) return null;

    return (
        <div>
            <VoiceRecordingConsent />
        </div>
    );
}